import { render, staticRenderFns } from "./BaseStationPowerRecord.vue?vue&type=template&id=358db82a&scoped=true&"
import script from "./BaseStationPowerRecord.vue?vue&type=script&lang=js&"
export * from "./BaseStationPowerRecord.vue?vue&type=script&lang=js&"
import style0 from "./BaseStationPowerRecord.vue?vue&type=style&index=0&id=358db82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358db82a",
  null
  
)

export default component.exports